import { render, staticRenderFns } from "./driverCard.vue?vue&type=template&id=e01d6fa2&"
import script from "./driverCard.vue?vue&type=script&lang=js&"
export * from "./driverCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports